import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './api/http.js'
import api from './api/api.js';
import common from './common/common.js';
// import mainHead from './components/mainHead.vue';
Vue.prototype.BASE_URL = "http://file.ssp.richmob.cn/"; //接口地址
import "@/assets/font/font.css";
// Vue.component('mainHead', mainHead);

// import 'swiper/dist/css/swiper.min.css';
// import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
// Vue.component('swiper',Swiper)
// Vue.component('swiper-slide',SwiperSlide)



//引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

/** 动画 */
// import tween from './common/tween.js';
// Vue.use(tween)

Vue.use(ElementUI)

// 转盘抽奖vue3引入
// import VueLuckyCanvas from '@lucky-canvas/vue'

//api接口表全局挂载
Vue.prototype.$api = api;
//接口请求全局注册
Vue.prototype.$http = http
Vue.prototype.$common = common

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')